import pages from "./website-seo.json";

const SITE_ORIGIN = "https://www.fimtosoft.net";
const OG_IMAGE = `${SITE_ORIGIN}/LOGO.png`;

// website-seo.json is also read by scripts/build-static-site.js, which writes
// these values into the static pages, so both paths describe a page the same way.
export const WEBSITE_SEO = Object.keys(pages).reduce((all, route) => {
  const { ru: _ru, de: _de, ...english } = pages[route];
  all[route] = {
    ...english,
    canonical: `${SITE_ORIGIN}${route}`,
  };
  return all;
}, {});

export const DEFAULT_OG_IMAGE = OG_IMAGE;
